import type { CarePlanTagDetail } from "@/types/care-plan-template";

import { DEFAULT_TAG_COLOR } from "./constants";
import { useCarePlanPrint } from "./print/care-plan-print-context";

interface CarePlanTagDisplayProps {
  tags: CarePlanTagDetail[];
  max?: number;
}

export function CarePlanTagDisplay({ tags, max = 3 }: CarePlanTagDisplayProps) {
  const printing = useCarePlanPrint();
  if (!tags.length) return null;

  const limit = printing ? tags.length : max;
  const visible = tags.slice(0, limit);
  const remaining = tags.length - limit;

  return (
    <div data-care-plan-tag-group className="flex flex-wrap gap-1">
      {visible.map((tag) => (
        <span
          key={tag.id}
          data-care-plan-tag
          className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-tiny font-medium"
          style={{
            backgroundColor: `${tag.color ?? DEFAULT_TAG_COLOR}20`,
            color: tag.color ?? DEFAULT_TAG_COLOR,
          }}
        >
          <span
            data-care-plan-tag-dot
            className="h-1.5 w-1.5 rounded-full"
            style={{ backgroundColor: tag.color ?? DEFAULT_TAG_COLOR }}
          />
          <span data-care-plan-tag-label>{tag.name}</span>
        </span>
      ))}
      {remaining > 0 && (
        <span className="inline-flex items-center rounded-full px-1.5 py-0.5 text-tiny text-foreground-secondary">
          +{remaining}
        </span>
      )}
    </div>
  );
}
